/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Annex2ReportFilterSpan.vue?vue&type=template&id=25c705bd&scoped=true"
import script from "./Annex2ReportFilterSpan.ts?vue&type=script&lang=js&external"
export * from "./Annex2ReportFilterSpan.ts?vue&type=script&lang=js&external"
import style0 from "./Annex2ReportFilterSpan.vue?vue&type=style&index=0&id=25c705bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c705bd",
  null
  
)

export default component.exports